
  import '/opt/buildhome/repo/components/bubble/demo/basic.tsx?watch=parent';
  export default "import React from 'react';\nimport { Bubble } from '@ant-design/x';\n\nconst App = () => <Bubble content=\"hello world !\" />;\n\nexport default App;\n";;
  